<template>
    <div class="m-c-map-country-popup" ref="countrypopup">
        {{ countryName }}
        <p v-if="countryProfileLink">
            <a class="c-link" :href="countryProfileLink">
                <span>{{ $t.message("linkToCountryProfile") }}</span>
                <span class="m-u-accessibility">{{ countryName }}</span>
            </a>
        </p>
    </div>
</template>

<script>
export default {
    name: "MapCountryPopup",
    props: {
        countryName: String,
        countryProfileLink: String,
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
